// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1p6S7","title":"Header_title__3OpCb","side":"Header_side__V1npV"};